import { Component, OnInit, ViewChild, Inject } from '@angular/core';
import { MatPaginator, MatSort, MatTableDataSource } from '@angular/material';
import { MatDialog, MatTable,VERSION, MatDialogRef, MatSnackBar, MAT_DIALOG_DATA } from '@angular/material';
import { APIObserverService } from '../../_observerServices/API-Observer';

export interface Element {
  operator: string;
  count: number;
 
}
@Component({
  selector: 'app-operator-wise-count',
  templateUrl: './operator-wise-count.component.html',
  styleUrls: ['./operator-wise-count.component.css']
})
export class OperatorWiseCountComponent implements OnInit {
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatTable) table: MatTable<any>;
    displayedColumns: string[] = ['operator', 'count'];
    dialogRef:any;
  ELEMENT_DATA: Element[] = [
    {  operator: 'Tata', count: null },
    {  operator: 'Airtel', count: null },
    {  operator: 'Vodafone', count: null  },
    {  operator: 'BSNL', count: null },
    {  operator: 'MTNL', count: null },
    {  operator: 'QTL', count: null  },
    {  operator: 'Jio', count: null  },
    {  operator: 'Vodafone Idea DLT', count: null  },
    {  operator: 'VMIPL', count: null  },
    {  operator: 'RCOM', count: null }
    ]
    operatorTable = new MatTableDataSource(this.ELEMENT_DATA);
  constructor(
    private obv: APIObserverService
  ) { }

  ngOnInit() {
    this.getCount();

  }
  getCount(){
    this.obv.ObserverPreferenceCount('TA').subscribe(r => {
      this.ELEMENT_DATA[0]['count'] = r.result
      })
    this.obv.ObserverPreferenceCount('AI').subscribe(r => {
       this.ELEMENT_DATA[1]['count'] = r.result
      })
      this.obv.ObserverPreferenceCount('VO').subscribe(r => {
        this.ELEMENT_DATA[2]['count'] = r.result
       })
        this.obv.ObserverPreferenceCount('BL').subscribe(r => {
        this.ELEMENT_DATA[3]['count'] = r.result
       })
        this.obv.ObserverPreferenceCount('ML').subscribe(r => {
        this.ELEMENT_DATA[4]['count'] = r.result
       })
       this.obv.ObserverPreferenceCount('QL').subscribe(r => {
        this.ELEMENT_DATA[5]['count'] = r.result
       })
       this.obv.ObserverPreferenceCount('JI').subscribe(r => {
        this.ELEMENT_DATA[6]['count'] = r.result
       })
       this.obv.ObserverPreferenceCount('VI').subscribe(r => {
        this.ELEMENT_DATA[7]['count'] = r.result
       })
       this.obv.ObserverPreferenceCount('VM').subscribe(r => {
        this.ELEMENT_DATA[8]['count'] = r.result
       })
       this.obv.ObserverPreferenceCount('RC').subscribe(r => {
        this.ELEMENT_DATA[9]['count'] = r.result
       })
      
  }

  onConfirmClick():void{
    this.dialogRef.close(true)
  }
}
